var _defs, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _g2, _path11, _g3, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _g4, _g5, _g6, _path28, _path29, _path30, _path31, _g7, _path32, _path33, _g8, _path34, _path35, _g9, _path36, _g0, _g1, _g10, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _rect, _path45, _path46, _g11, _path47, _path48, _g12, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _g13, _path58, _path59, _path60, _g14, _path61, _path62, _path63, _g15, _path64, _g16, _path65, _path66, _g17, _path67, _path68, _g18, _g19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightImg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_47",
    "data-name": "Group 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 602.625,
    height: 475.89,
    viewBox: "0 0 602.625 475.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M2490.92,334.034l-85.408-13.507,23.75-10.574Z",
    transform: "translate(-2405.512 -309.953)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.535,
    y1: 0.917,
    x2: 0.438,
    y2: -0.238,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ea6200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc045"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M2033.4,530.848h271.435l.113,371.033H2033.4Z",
    transform: "translate(-2033.402 -530.848)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.503,
    y1: 1.519,
    x2: 0.499,
    y2: 0.215,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#002990"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#0a4aad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#1879d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#2096f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24a1fb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M1967.2,582.1h207.388l64.161,28.547V953.131H1967.2Z",
    transform: "translate(-1967.196 -582.099)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.495,
    y1: 1.001,
    x2: 0.506,
    y2: -0.032,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M1702.083,1459.115c3.757,16.491-1.3,55.36-3.182,85.847l.294-.028a5.1,5.1,0,0,0,2.255,3.733c2.021,1.1,5.543,1.963,6.738,3.106.862.825,4.162,5.5-7.649,5.185-8.39-.221-10.389-.806-11.288-2.168-.126-.189-6.977-64.085-7.85-69.338-1.5,6.7-18.462,63.8-18.457,63.839a14.318,14.318,0,0,0,2.977,5.363c.458,1.637,1.553,4.519-6.581,4.449s-6.463-2.126-7.335-3.445c3.609-33.948,9.412-88.652,11.232-97.686l.508-.469c1.45-58.109,32.327-43.133,29.547-7.955-.314,3.975,7.393,4.084,8.79,9.566",
    transform: "translate(-1652.005 -1418.495)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.407,
    y1: 0.873,
    x2: 0.678,
    y2: -0.215,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#031542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    stopColor: "#041c4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.291,
    stopColor: "#093065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#115090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.798,
    stopColor: "#1b7ccb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24a1fb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M1774.915,1380.212c3.551,7.794,13.678,17.138,23.842,18.652,9.094,1.355,30.262-12.072,29.289-14.552-1.058-2.7-5.469-2.957-6.886-.989-5.492,1.643-22.112,3.5-23.35,3.41-1.173-.083-13.835-17.131-21.041-19.747-.855-.551-4.354,9.461-1.853,13.226",
    transform: "translate(-1774.029 -1366.964)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.49,
    y1: 1.439,
    x2: 0.504,
    y2: 0.164,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M1670.056,1368.383c-3.385,5.047,7.49,26.125,4.667,51.766,15.832,2.719,30.312,1.51,39.766-1.5-.443-10.448-.471-46.718-11.852-55.472-11.263-3.156-27.944-1.708-32.582,5.207",
    transform: "translate(-1669.396 -1361.586)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.551,
    y1: 1.461,
    x2: 0.483,
    y2: 0.176,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M1718.012,1275.1c-3.847,1.972-8.278-.367-10.518,2.272-1.11,1.307-1,3.191.245,6.1.366.858.855,1.488-.593.818-.665-.307-1.76-.738-2.134-.436a1.722,1.722,0,0,0,.252,2.542c.3.2.858.506.858.506-5.176-.981-7.332-5.65-7.259-9.41a15.987,15.987,0,0,1,.409-3.414,3.743,3.743,0,0,1-.165-1.1,3.569,3.569,0,0,1,2.463-3.444,3.473,3.473,0,0,1,3.374-3,3.281,3.281,0,0,1,1.433.329l.171-.044a3.626,3.626,0,0,1,5.55-.854,4.935,4.935,0,0,1,3.965-2.1c2.84,0,5.142,2.589,5.142,5.782a6,6,0,0,1-2.273,4.8,5.681,5.681,0,0,1-.92.658",
    transform: "translate(-1698.861 -1263.858)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.522,
    y1: 0.903,
    x2: 0.454,
    y2: -0.334,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M1650.359,1387.963c-.26-5.538-4.153-11.778-8.076-7.082-6.785,8.124-13.635,27.243-11.78,32.816,1.93,5.595,24.21,8.917,29.02,6.9,2.267-.948,2.921-1.153,3.595-2.685.392-.89.8-2.277-1.125-3.127-5.1-2.257-18.826-5.817-19.118-7.208-1-7.468,7.805-12.739,7.483-19.617",
    transform: "translate(-1630.195 -1379.227)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -0.326,
    y1: 1.061,
    x2: 0.663,
    y2: 0.389,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M1547.093,852.316c7.456,9.319,14.894,21,17.7,30.1v3.7h28.688v-3.7c2.808-9.1,10.246-20.777,17.7-30.1,1.3-1.526,2.144-3.006,3.32-4.538a38.725,38.725,0,0,0,5.922-19.615,39.422,39.422,0,0,0-38.559-40.266c-.917-.024-1.827-.016-2.729.021-.9-.037-1.813-.046-2.729-.021a39.422,39.422,0,0,0-38.559,40.266,38.737,38.737,0,0,0,5.921,19.615c1.177,1.532,2.024,3.012,3.321,4.538",
    transform: "translate(-1537.837 -787.884)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.483,
    y1: 0.65,
    x2: 0.56,
    y2: -0.019,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M1639.415,800.821c10.161,0,18.4,6.342,18.4,14.165s-8.237,14.165-18.4,14.165-18.4-6.342-18.4-14.165,8.237-14.165,18.4-14.165",
    transform: "translate(-1621.017 -800.821)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 0.5,
    y1: 1.21,
    x2: 0.5,
    y2: -0.685,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7a12e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M1755.774,881.678c1.823,4.988.188,10.171-3.653,11.574s-8.433-1.5-10.256-6.491-.188-10.171,3.653-11.575,8.433,1.5,10.256,6.491",
    transform: "translate(-1741.119 -874.834)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0.266,
    y1: 0.921,
    x2: 1.208,
    y2: -0.774,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M1625.819,1117.654h29.618a1.007,1.007,0,0,1,1.022.985v20.74h-.07l-3.032,4.76-3.991.03v.014c0,3.433-3.912,6.215-8.738,6.215-4.769,0-8.645-2.717-8.736-6.093l-3.69.028-3.33-4.954h-.074v-20.74a1.007,1.007,0,0,1,1.021-.985",
    transform: "translate(-1624.798 -1117.654)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0.5,
    y1: 0.552,
    x2: 0.5,
    y2: -0.304,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a2bee5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ddebff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M3060.2,1056.753a19.136,19.136,0,0,1-1.135,6.187,17.85,17.85,0,0,0,.07,11c1.072,3.643-2.085,9.959-2.857,10.216s-10.715,2.057-12.772,1.887-11.573-11.316-11.573-11.316l1.028-9.773Z",
    transform: "translate(-3031.935 -1056.753)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 0.471,
    y1: 0.911,
    x2: 0.568,
    y2: -0.459,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M3064.7,1236.842c3.728,12.372,37.241,10.082,29.845,50.841-12.667,2.128-29.293,2.681-39.4.263-5.31-18.709-35.862-4.077-20.091-50.515,3.229-7.545,28.458-5.419,29.65-.589",
    transform: "translate(-3030.575 -1232.479)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 0.49,
    y1: 0.907,
    x2: 0.514,
    y2: -0.087,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M3013.61,1024.057s7.11,2.715,10.118,1.289c5.194-2.47,4.406-14.19-8.759-14.321-11.186.2-10.484,13.639-25.072,14.647-7.736.535-12.46,7-9.844,17.673.021.025,1.171-3.4,4.028-2.982-4.657,5.378.034,11.686.733,12.778,1.665-8.161,6.562-13.861,20.472-15.524,5.779-2.185.694-14.5,8.323-13.56",
    transform: "translate(-2979.328 -1011.024)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 0.431,
    y1: 0.971,
    x2: 0.733,
    y2: -1.095,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M1838.792,389.488h36.468a12.229,12.229,0,0,1,12.193,12.193V457.5H1782.667v-68.01h-.01v-8.92a8.945,8.945,0,0,1,8.919-8.919h37.2c2.481,0,3.563,2.217,4.509,4.509Z",
    transform: "translate(-1782.657 -371.649)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 0.498,
    y1: 0.88,
    x2: 0.503,
    y2: -0.09,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M2823.649,1380.779c-1.682-3.5-.389-10.355,3.177-11.9.943-.407,3.6-1.689,5.333-.715,6.123,3.434,14.6,25.212,15.563,33.227.784,6.576,1.723,22.568-.674,31.212-.518,1.866-3.86.474-4.692-.034-2.093-.73-2.47-15.253-6.647-29.294-3.443-11.577-10.549-19.358-12.059-22.5",
    transform: "translate(-2822.919 -1367.812)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 0.788,
    y1: 0.599,
    x2: -0.193,
    y2: 0.262,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03096b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M2707.466,1449c-5.115,8.937,5.879,59.724,7.776,90.522l-.3-.028a5.152,5.152,0,0,1-2.279,3.772c-2.042,1.115-9.555,2.03-10.763,3.185-.87.833-2.32,4.186,9.611,3.871,8.476-.223,12.567.505,13.475-.87.7-1.057.454-6.264.3-8.6l.05,0c1.1-21.049-1.1-40.492,3.013-65.241,3.257,14.554,6.941,28.264,9.1,35.971,1.3,4.648,8.907,25.209,8.268,29.806-.142,1.022-4.938,1.484-6.962,3.111-.845.808-2.417,4.188,5.8,4.116s12.18.49,13.06-.843c.825-1.245-5.325-35.925-5.806-40.817-2.121-21.612-2.783-45.5-5.618-59.583l-.006,0c-1.465-58.7-32.657-43.572-29.849-8.035.317,4.016-7.469,4.126-8.879,9.663",
    transform: "translate(-2701.342 -1407.964)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 0.598,
    y1: 0.87,
    x2: 0.371,
    y2: 0.013,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M2763.89,1286.833a10.885,10.885,0,0,1-5.573-3.038c-.594-.653-1.546-6.276-1.877-6.392-1.263-.442-1.867,3.9-1.867,3.9-.187-.227-.856-.414-1.008-1.134-.067-.319.358-2.115.082-2.569-.2-.333-1.579-1.52-1.878-1.965-2.436-3.619-5.224-7.533-1.93-10.329a3.8,3.8,0,0,1,2.089-.771,7.573,7.573,0,0,0,3.174-.814c7.988-3.776,23.641,1.992,15.385,18.129-1.156,2.259-4.7,4.783-6.594,4.979",
    transform: "translate(-2748.332 -1262.611)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 0.477,
    y1: 0.929,
    x2: 0.544,
    y2: -0.313,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M2744.021,1357.3c4.156,0,10.087,1.27,12.6,4.216,3.606,4.225,2.715,55.734,1.614,62.319-3.587,9.85-34.086,6.043-43.328.817l1.691-59.495c6.615-10.09,16.968-7.858,27.42-7.858",
    transform: "translate(-2714.91 -1357.092)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 0.5,
    y1: 0.645,
    x2: 0.5,
    y2: 0.074,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M2652.292,1415.505c-5.116,2.53-20.932-13.7-22.2-18.057s3.819-6.936,3.819-6.936,11.517,9.474,13.479,8.82c1.481-.492,5.646-13.19,9.562-18.372,4.134-3.775,13.108,22.577-4.663,34.545",
    transform: "translate(-2629.892 -1380.594)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 0.396,
    y1: 0.713,
    x2: 0.714,
    y2: 0.062,
    xlinkHref: "#linear-gradient-17"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M2307.088,376.455q2.728-.616,5.5-1.046l-.447-2.8c-1.905.3-3.8.657-5.685,1.082Zm-8.082,2.251c1.764-.587,3.558-1.13,5.36-1.591l-.721-2.742c-1.87.486-3.713,1.036-5.545,1.645Zm-7.777,3.083c1.692-.78,3.4-1.495,5.149-2.151l-1.008-2.651c-1.81.679-3.583,1.42-5.339,2.229Zm-7.339,3.951c1.557-.976,3.2-1.9,4.836-2.732l-1.3-2.524c-1.713.875-3.424,1.832-5.052,2.854Zm-6.756,4.852c1.415-1.177,2.906-2.294,4.427-3.332l-1.611-2.34c-1.594,1.091-3.154,2.256-4.639,3.491Zm-6,5.732.4-.439.641-.682c.323-.334.646-.665.974-.995l.658-.645c.407-.39.817-.775,1.234-1.155l-1.922-2.1-.6.554-.349.328-.694.67-.687.685-.341.348-.339.352-.337.356-.336.359-.417.456Zm-5.094,6.535.38-.561.282-.409.286-.4.287-.4.29-.4.293-.393.295-.389.3-.385.3-.381.3-.377.281-.346-2.209-1.795-.3.365-.317.4-.313.4-.312.4-.309.408-.306.413-.305.417-.3.421-.3.425-.3.429-.393.583Zm-4.1,7.2.316-.651.239-.478.241-.472.245-.468.247-.464.25-.459.253-.456.256-.451.259-.447.309-.519-2.437-1.474-.334.561-.271.468-.269.473-.264.477-.263.482-.259.485-.256.491-.253.5-.25.5-.328.674Zm-3.079,7.707.217-.654.188-.547.191-.541.195-.537.2-.532.2-.527.205-.523.209-.518.336-.805-2.621-1.118-.134.314-.221.537-.218.54-.214.547-.211.55-.206.556-.2.56-.2.565-.2.57-.225.678Zm-2.112,8.059.112-.546.131-.616.137-.61.14-.606.144-.6.149-.6.153-.591.157-.586.179-.646-2.737-.795-.191.694-.164.608-.159.614-.154.619-.15.623-.145.629-.141.634-.137.639-.113.546Zm-1.227,8.246.031-.33.071-.669.076-.672.083-.674.087-.669.092-.663.1-.657.1-.653.086-.532-2.81-.474-.09.554-.1.675-.1.68-.095.685-.091.69-.085.7-.08.7-.072.695-.032.331Zm-.286,8.31-.021-.892,0-.626v-.629l0-.634.012-.636.019-.64.024-.644.042-.838-2.843-.184-.045.891-.025.67-.019.668-.014.664-.006.66v.657l.006.654.02.918Zm.792,8.261-.121-.75-.084-.577-.08-.582-.074-.584-.069-.589-.064-.591-.057-.595-.053-.6-.048-.621-2.843.169.053.675.055.626.06.623.067.619.072.615.079.612.083.609.09.606.124.777Zm1.935,8.062-.167-.537-.159-.529-.155-.532-.15-.536-.146-.538-.14-.541-.136-.545-.131-.548-.127-.551-.106-.489-2.787.58.114.515.132.578.137.575.143.571.148.569.153.564.158.562.161.558.168.555.176.563Zm3.077,7.718-.334-.7-.222-.482-.219-.485-.214-.488-.211-.491-.208-.494-.2-.5-.2-.5-.194-.5-.172-.457-2.673.969.182.483.2.528.207.525.214.521.217.518.22.515.226.511.229.509.233.5.344.723Zm4.124,7.227-.413-.629-.277-.433-.275-.437-.272-.44-.268-.443-.264-.446-.262-.449-.258-.452-.255-.455-.314-.573-2.515,1.319.338.617.267.476.271.472.274.469.277.466.281.462.284.46.286.457.291.453.424.647Zm5.039,6.659c-.647-.761-1.274-1.526-1.894-2.308-.416-.535-.825-1.07-1.229-1.614l-.329-.448-2.318,1.635.353.484.317.425.318.421q.482.627.972,1.247l.329.41c.43.527.863,1.048,1.3,1.566ZM2276,486.36c-1.357-1.281-2.671-2.595-3.938-3.966l-2.1,1.9c1.309,1.419,2.671,2.782,4.077,4.107Zm6.393,5.439c-1.475-1.141-2.923-2.329-4.323-3.561l-1.888,2.113q2.172,1.909,4.462,3.677Zm6.877,4.86q-2.36-1.529-4.633-3.177l-1.682,2.279c1.558,1.133,3.141,2.216,4.759,3.265Zm7.253,4.3c-1.649-.9-3.271-1.831-4.877-2.808l-1.487,2.41q2.466,1.5,5,2.877Zm7.552,3.761a55.854,55.854,0,0,1-5.068-2.449l-1.3,2.515a57.172,57.172,0,0,0,5.191,2.508Zm7.805,3.2c-1.721-.626-3.56-1.321-5.225-2.069l-1.12,2.6c1.777.747,3.556,1.468,5.37,2.126Zm3.684,1.243c-.344-.094-.7-.215-1.039-.326l-.882,2.689c.368.123.76.252,1.135.355Zm-.209-134.142c1.821-.217,3.688-.392,5.524-.429h-.008l-.029-2.832a56.783,56.783,0,0,0-5.834.448Z",
    transform: "translate(-2019.115 -350.811)",
    fill: "#a1c7e9",
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(277.895 2.935)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_275",
    "data-name": "Rectangle 275",
    width: 85.408,
    height: 24.081,
    fill: "url(#linear-gradient)"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M2569.273,326.9l-34.7-27.016-18.466,6.25Z",
    transform: "translate(-2205.97 -299.885)",
    fill: "#f9c278"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M2472.89,356.876l1.87,9.445,63.9.957Z",
    transform: "translate(-2175.353 -340.262)",
    fill: "#cb4700"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M1981.771,1577.605s17.03-7.748,14.5-19.743-16.371-10.738-14.5-20.209,10.964-24.223,2.123-34.959-23.545-4.3-25.388-20.948c-1.486-13.415-7.685-22.916-19.7-20.131-11.118,2.58-19.408,11.187-19.614,31.662-.224,21.8-15.575,15.674-15.766,31.734-.191,16.175,12.693,16.175,17.725,27.026,2.376,5.126-3.821,23.139,14.5,25.567Z",
    transform: "translate(-1771.899 -1122.605)",
    fill: "#b6e1f8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M2024.989,1490.2s-.042.366-.107,1.081c-.194,2.147-.584,7.376-.584,14.664-.007,21.323,3.359,60.27,24.583,91.356a.977.977,0,0,1,.09.166h-2.222c-21.029-31.474-24.3-70.212-24.31-91.523a154.6,154.6,0,0,1,.7-15.956.929.929,0,1,1,1.847.212",
    transform: "translate(-1856.217 -1142.467)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M1912.365,1677.1s2.68-14.806-7.37-20.834-20.31-10.719-19.2-20.432-1.626-21.177-17.727-21.392c-9.953-.13-6.216-10.625-16.329-12.716-6.148-1.273-10.2,5.144-10.986,11.445-.9,7.176,3.167,14.23-1.492,20.074-6.047,7.573-8.5,21.695,4.493,25.713s1.414,16.323,19.111,18.142h49.5Z",
    transform: "translate(-1722.958 -1222.1)",
    fill: "#b6e1f8",
    fillRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M1891.805,1624.075c.339,9.432,4.523,22.857,11.681,35.666s17.274,25.036,29.361,32.237a.907.907,0,0,1,.383.438h-3.193c-11.648-7.539-21.266-19.4-28.173-31.768-7.269-13.035-11.545-26.618-11.918-36.5a.93.93,0,0,1,1.859-.069",
    transform: "translate(-1762.347 -1237.415)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M2710.078,1272.693s-36.883-16.78-31.406-42.763,35.46-23.255,31.406-43.768-23.745-52.465-4.6-75.717,50.995-9.313,54.988-45.369c3.219-29.057,16.645-49.635,42.659-43.6,24.081,5.588,42.036,24.231,42.482,68.575.485,47.218,33.735,33.951,34.147,68.735.414,35.031-27.49,35.031-38.39,58.536-5.146,11.1,8.277,50.115-31.4,55.374Z",
    transform: "translate(-2320.752 -810.37)",
    fill: "#78daff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M2966.87,1083.388c0,.006.092.794.23,2.341.42,4.649,1.265,15.975,1.265,31.759.014,46.182-7.274,130.536-53.243,197.865a1.944,1.944,0,0,0-.2.361h4.813c45.548-68.17,52.641-152.071,52.653-198.227a335.527,335.527,0,0,0-1.522-34.559,2.013,2.013,0,1,0-4,.459",
    transform: "translate(-2488.526 -853.393)",
    fill: "#fff"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M2938.1,1488.19s-5.8-32.069,15.963-45.123,43.989-23.216,41.577-44.254,3.521-45.865,38.4-46.331c21.558-.281,13.463-23.013,35.366-27.542,13.314-2.756,22.094,11.142,23.792,24.788,1.941,15.542-6.859,30.82,3.233,43.479,13.1,16.4,18.415,46.986-9.732,55.69s-3.062,35.353-41.393,39.294H2938.1Z",
    transform: "translate(-2504.447 -1025.867)",
    fill: "#bcecff",
    fillRule: "evenodd"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M3167.148,1373.339c-.735,20.428-9.8,49.5-25.3,77.246-15.491,27.765-37.414,54.227-63.593,69.821a2,2,0,0,0-.829.951h6.917c25.229-16.328,46.057-42.013,61.02-68.806,15.745-28.232,25-57.651,25.811-79.063a2.014,2.014,0,0,0-4.026-.15",
    transform: "translate(-2603.655 -1059.035)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M2069.095,572.031H2340.53l.113,371.033H2069.095Z",
    transform: "translate(-1889.271 -492.695)",
    fill: "#003398",
    fillRule: "evenodd"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(169.418 67.33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_276",
    "data-name": "Rectangle 276",
    width: 271.548,
    height: 371.033,
    fill: "url(#linear-gradient-2)"
  })))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M1793.124,1822.038c-147.216,0-266.557,7.2-266.557,16.077s119.341,16.077,266.557,16.077,266.557-7.2,266.557-16.077-119.342-16.077-266.557-16.077",
    transform: "translate(-1504.901 -1378.302)",
    fill: "#b6e1f8",
    fillRule: "evenodd",
    opacity: 0.3
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(150.118 82.271)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_277",
    "data-name": "Rectangle 277",
    width: 271.548,
    height: 371.033,
    fill: "url(#linear-gradient-3)"
  })))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M2097.5,1094.165h-25.927a3.234,3.234,0,0,0-2.322.995h-.007a3.413,3.413,0,0,0-.959,2.388v26.681a3.426,3.426,0,0,0,.966,2.389,3.235,3.235,0,0,0,2.322.995H2097.5a3.225,3.225,0,0,0,2.32-.987v-.008a3.424,3.424,0,0,0,.968-2.389v-26.681a3.417,3.417,0,0,0-.96-2.388l-.008-.008a3.226,3.226,0,0,0-2.32-.987m-25.927-4.05H2097.5a7.107,7.107,0,0,1,5.1,2.182l.007.008a7.522,7.522,0,0,1,2.121,5.243v26.681a7.521,7.521,0,0,1-2.121,5.251l0,0a7.1,7.1,0,0,1-5.1,2.185h-25.927a7.106,7.106,0,0,1-5.1-2.182,7.523,7.523,0,0,1-2.12-5.251v-26.681a7.521,7.521,0,0,1,2.125-5.247l0,0A7.105,7.105,0,0,1,2071.571,1090.115Z",
    transform: "translate(-1885.908 -859.748)",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M2260.231,1094.831h49.138a3.078,3.078,0,0,1,0,6.157h-49.138a3.078,3.078,0,0,1,0-6.157",
    transform: "translate(-2022.507 -863.089)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M2096.851,1310.028h-25.493a3.179,3.179,0,0,0-2.282.978h-.008a3.364,3.364,0,0,0-.943,2.349v26.235a3.362,3.362,0,0,0,.951,2.349,3.18,3.18,0,0,0,2.282.978h25.493a3.173,3.173,0,0,0,2.282-.971v-.008a3.363,3.363,0,0,0,.951-2.349v-26.235a3.362,3.362,0,0,0-.943-2.349l-.008-.008a3.172,3.172,0,0,0-2.282-.971m-25.493-3.982h25.493a6.986,6.986,0,0,1,5.011,2.145l.008.008a7.4,7.4,0,0,1,2.085,5.156v26.235a7.4,7.4,0,0,1-2.085,5.164l0,0a6.987,6.987,0,0,1-5.015,2.149h-25.493a6.986,6.986,0,0,1-5.019-2.145,7.4,7.4,0,0,1-2.084-5.164v-26.235a7.4,7.4,0,0,1,2.088-5.16l0,0A6.988,6.988,0,0,1,2071.359,1306.046Z",
    transform: "translate(-1885.844 -1012.731)",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M2095.382,1356.47l13.225-12.69a2.509,2.509,0,0,1,3.612.135,2.686,2.686,0,0,1-.132,3.719l-15.172,14.55-.039.032a2.512,2.512,0,0,1-3.6-.246l-7.31-8.61a2.691,2.691,0,0,1,.239-3.711,2.513,2.513,0,0,1,3.6.246Z",
    transform: "translate(-1900.777 -1038.967)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M2260.229,1150.409h149.344a3.079,3.079,0,0,1,0,6.158H2260.229a3.079,3.079,0,1,1,0-6.158",
    transform: "translate(-2022.504 -902.465)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M2260.229,1205.989h149.344a3.078,3.078,0,1,1,0,6.157H2260.229a3.078,3.078,0,1,1,0-6.157",
    transform: "translate(-2022.504 -941.842)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M2260.231,1307.176h49.138a3.078,3.078,0,0,1,0,6.157h-49.138a3.078,3.078,0,0,1,0-6.157",
    transform: "translate(-2022.507 -1013.532)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M2260.229,1362.754h149.344a3.079,3.079,0,0,1,0,6.158H2260.229a3.079,3.079,0,1,1,0-6.158",
    transform: "translate(-2022.504 -1052.908)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M2260.229,1418.334h149.344a3.078,3.078,0,1,1,0,6.157H2260.229a3.078,3.078,0,1,1,0-6.157",
    transform: "translate(-2022.504 -1092.285)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M2095.382,1143.221l13.225-12.691a2.509,2.509,0,0,1,3.612.136,2.685,2.685,0,0,1-.132,3.718l-15.172,14.551-.039.031a2.512,2.512,0,0,1-3.6-.246l-7.31-8.609a2.691,2.691,0,0,1,.239-3.711,2.513,2.513,0,0,1,3.6.247Z",
    transform: "translate(-1900.777 -887.885)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M2096.851,1528.627h-25.493a3.176,3.176,0,0,0-2.282.979h-.008a3.36,3.36,0,0,0-.943,2.348v26.235a3.359,3.359,0,0,0,.951,2.348,3.176,3.176,0,0,0,2.282.979h25.493a3.173,3.173,0,0,0,2.282-.971v-.008a3.359,3.359,0,0,0,.951-2.348v-26.235a3.358,3.358,0,0,0-.943-2.348l-.008-.008a3.176,3.176,0,0,0-2.282-.971m-25.493-3.982h25.493a6.987,6.987,0,0,1,5.011,2.146l.008.008a7.4,7.4,0,0,1,2.085,5.156v26.235a7.4,7.4,0,0,1-2.085,5.164l0,0a6.986,6.986,0,0,1-5.015,2.149h-25.493a6.984,6.984,0,0,1-5.019-2.145,7.4,7.4,0,0,1-2.084-5.164v-26.235a7.394,7.394,0,0,1,2.088-5.159l0,0A6.985,6.985,0,0,1,2071.359,1524.645Z",
    transform: "translate(-1885.844 -1167.604)",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M2095.382,1575.07l13.225-12.689a2.511,2.511,0,0,1,3.612.135,2.686,2.686,0,0,1-.132,3.719l-15.172,14.551-.039.031a2.512,2.512,0,0,1-3.6-.247l-7.31-8.609a2.691,2.691,0,0,1,.239-3.71,2.513,2.513,0,0,1,3.6.246Z",
    transform: "translate(-1900.777 -1193.842)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M2260.231,1525.775h49.138a3.078,3.078,0,0,1,0,6.157h-49.138a3.078,3.078,0,0,1,0-6.157",
    transform: "translate(-2022.507 -1168.405)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M2260.229,1581.353h149.344a3.079,3.079,0,0,1,0,6.158H2260.229a3.079,3.079,0,1,1,0-6.158",
    transform: "translate(-2022.504 -1207.781)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M2260.229,1636.934h149.344a3.078,3.078,0,1,1,0,6.157H2260.229a3.078,3.078,0,1,1,0-6.157",
    transform: "translate(-2022.504 -1247.159)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M2678.6,582.1l35.75,44.014,28.41-15.467Z",
    transform: "translate(-2321.095 -499.828)",
    fill: "#ea6200",
    fillRule: "evenodd"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(58.234 326.096)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_278",
    "data-name": "Rectangle 278",
    width: 61.146,
    height: 159.779,
    transform: "translate(-0.8 -19.099)",
    fill: "url(#linear-gradient-4)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(93.806 311.074)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_279",
    "data-name": "Rectangle 279",
    width: 56.604,
    height: 33.784,
    transform: "translate(-1.615 -0.529)",
    fill: "url(#linear-gradient-5)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(63.303 309.506)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_280",
    "data-name": "Rectangle 280",
    width: 47.819,
    height: 62.848,
    transform: "translate(-2.725 -1.567)",
    fill: "url(#linear-gradient-6)"
  })))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M1679.632,1438.489c1.555,8.828,3.636,20.916,2.343,32.654q.832.142,1.658.27c.628-1.914,1.3-3.186,1.957-12.106s-3-25.745-3-25.745l-2.953,4.925Z",
    transform: "translate(-1613.344 -1103.075)",
    fill: "#146ccb",
    fillRule: "evenodd"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M1688.471,1504.261c.177,2.429.28,4.933.278,7.5,1.926.352,5.414-.166,11.016-.241,6.961-.094,9.882,1.709,9.882,1.709s.87-4.32.559-5.1-6.277-2.207-9.385-2.984c-2.805-.7-9.307-.694-12.351-.891",
    transform: "translate(-1619.607 -1153.163)",
    fill: "#146ccb",
    fillRule: "evenodd"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M1728.047,1296.533a10.252,10.252,0,0,1-4.411,4.759l.059,3.219.469.4c1.835,1.966-.152,6-2.242,5.878-5.284.261-9.341-4.073-7.752-6.424l.69-.769.152-4.558c-.273-.015-2.257-1.143-2.848-1.325a3.063,3.063,0,0,1-1.516-2.521c-.058-1.2,1.8-.812,1.8-.812-2.249-3.079-4.8-5.593-1.493-8.364s10.889-4.389,10.889-4.389l4.565-1.583c-.581,1.575.2,6.832,1.369,10.113,1.051,2.944,1.765,3.4.27,6.377",
    transform: "translate(-1634.414 -994.308)",
    fill: "#f4b1b1",
    fillRule: "evenodd"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M1736.1,1347.368s2.583,4.431,4.7,4.832,1.037.1,1.828.01l-.06-3.22c-1.462.235-2.892.12-6.472-1.621",
    transform: "translate(-1653.351 -1042.007)",
    fill: "#e98385",
    fillRule: "evenodd"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(71.893 281.016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_281",
    "data-name": "Rectangle 281",
    width: 22.415,
    height: 23.041,
    transform: "translate(-0.071 0)",
    fill: "url(#linear-gradient-7)"
  })))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M1751.89,1373.018l4.924,8.16-81.717,52.04c-2.9,1.845-7.468.462-9.245-2.483s-.961-7.8,2.022-9.515Z",
    transform: "translate(-1602.922 -1060.179)",
    fill: "#254fb7"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M2024.621,1166.033a38.94,38.94,0,1,0,12.93,26.85,38.816,38.816,0,0,0-12.93-26.85m-57.98,58.772a2.307,2.307,0,0,1-.754.73,2.35,2.35,0,0,1-3.219-.8l-5.435-9.007a2.344,2.344,0,0,1,1.261-3.434,43.749,43.749,0,1,1,11.056,15.361Q1968.024,1226.294,1966.642,1224.8Z",
    transform: "translate(-1808.414 -903.137)",
    fill: "#254fb7"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(51.876 314.649)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_282",
    "data-name": "Rectangle 282",
    width: 35.267,
    height: 46.428,
    transform: "translate(-1.548 -3.042)",
    fill: "url(#linear-gradient-8)"
  })))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M1732.891,1502.789l2.18.707,4.876-.853c.544-.245,4.092-1.073,3.149.1-.663.822-2.7,2.175-2.653,2.266.653,1.189,7.258,2.972,7.323,3.08.917,1.5-3.342.617-4.071.5a26.836,26.836,0,0,1,2.66,1.388,1.476,1.476,0,0,1-1.387.416,18.053,18.053,0,0,0-2.809-.628c-.2.147,2.7,1.381,2.5,1.5a1.3,1.3,0,0,1-1.075.166,24.871,24.871,0,0,0-2.735-.756c-.256.1,1.879.862,1.637.936-.189.057-.239.4-.428.372-5.1-.674-5.019-3.293-10.882-3.908-3.261-.343.59-4.784,1.711-5.288",
    transform: "translate(-1648.957 -1151.653)",
    fill: "#f4b1b1",
    fillRule: "evenodd"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M1939.816,1412.35c.381-.617,2.742,1.227,2.742,1.227l-2.352-2.717c-.089-1.19,1.914-.44,2.538.189l-1.46-2.308s.165-.579.6-.382a19.222,19.222,0,0,1,1.783,1.187l-1.61-2.051a.913.913,0,0,1,1.11-.11,4.875,4.875,0,0,1,2.238,6.709c-2.338,3.624-5.886-1.265-5.591-1.744",
    transform: "translate(-1797.668 -1084.437)",
    fill: "#f4b1b1",
    fillRule: "evenodd"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(24.952 142.261)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_283",
    "data-name": "Rectangle 283",
    width: 83.733,
    height: 98.241,
    transform: "translate(-0.565 -0.011)",
    fill: "url(#linear-gradient-9)"
  })))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M1601.255,816.262a32.2,32.2,0,1,1-32.2,32.2,32.2,32.2,0,0,1,32.2-32.2",
    transform: "translate(-1535.002 -665.728)",
    fill: "#f7a12e",
    fillRule: "evenodd"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(49.2 146.032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_284",
    "data-name": "Rectangle 284",
    width: 36.796,
    height: 28.33,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-10)"
  })))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(84.212 167.608)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_285",
    "data-name": "Rectangle 285",
    width: 17.555,
    height: 20.874,
    transform: "translate(-1.078 -1.05)",
    fill: "url(#linear-gradient-11)"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(50.302 238.395)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_286",
    "data-name": "Rectangle 286",
    width: 31.661,
    height: 32.743,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-12)"
  })))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M1615.509,1128.569h32.6a7.059,7.059,0,0,0,3.157,9.47,3.157,3.157,0,1,0,0,6.313,3.167,3.167,0,0,1-3.157,3.157h-32.6a7.059,7.059,0,0,0-3.156-9.47,3.157,3.157,0,0,0,0-6.314,3.165,3.165,0,0,1,3.156-3.156",
    transform: "translate(-1565.678 -886.992)",
    fill: "#a2bee5",
    fillRule: "evenodd"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M1621.3,1132.3h32.63a.758.758,0,0,1,.756.756h0a.758.758,0,0,1-.756.755H1621.3a.758.758,0,0,1-.756-.755h0a.758.758,0,0,1,.756-.756",
    transform: "translate(-1571.48 -889.632)",
    fill: "#dceafd",
    fillRule: "evenodd"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M1621.3,1153.226h32.63a.758.758,0,0,1,.756.757h0a.758.758,0,0,1-.756.755H1621.3a.758.758,0,0,1-.756-.755h0a.758.758,0,0,1,.756-.757",
    transform: "translate(-1571.48 -904.461)",
    fill: "#dceafd",
    fillRule: "evenodd"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M1621.3,1174.158h32.63a.758.758,0,0,1,.756.757h0a.758.758,0,0,1-.756.756H1621.3a.758.758,0,0,1-.756-.756h0a.759.759,0,0,1,.756-.757",
    transform: "translate(-1571.48 -919.291)",
    fill: "#dceafd",
    fillRule: "evenodd"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M1633.262,948.781h0a4.5,4.5,0,0,0-7.688,3.183v2.725a4.494,4.494,0,0,0,1.324,3.182h0a4.5,4.5,0,0,0,3.184,1.323h4.506v-7.231a4.5,4.5,0,0,0-1.323-3.184m-3.183-2.9a6.068,6.068,0,0,1,4.3,1.787v0a6.068,6.068,0,0,1,1.786,4.3v8.811h-6.085a6.067,6.067,0,0,1-4.3-1.786h0a6.067,6.067,0,0,1-1.787-4.3v-2.725a6.063,6.063,0,0,1,1.787-4.3l0,0A6.064,6.064,0,0,1,1630.078,945.879Z",
    transform: "translate(-1573.925 -757.56)",
    fill: "#fff"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M1695.075,947.666a6.061,6.061,0,0,1,8.595,0v0a6.066,6.066,0,0,1,1.787,4.3v2.725a6.1,6.1,0,0,1-6.085,6.086h-6.086v-8.811a6.066,6.066,0,0,1,1.787-4.3Zm4.3-.208a4.516,4.516,0,0,0-4.507,4.506V959.2h4.507a4.521,4.521,0,0,0,4.506-4.506v-2.725a4.5,4.5,0,0,0-1.323-3.184h0A4.5,4.5,0,0,0,1699.371,947.459Z",
    transform: "translate(-1623.017 -757.56)",
    fill: "#fff"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M1660.326,1028.318V991.56h11.188v36.759h-1.58V993.139h-8.028v35.179Z",
    transform: "translate(-1599.666 -789.923)",
    fill: "#fff"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M1551.092,716.846h0a2.219,2.219,0,0,1,.81,3.023l-4.836,8.377a2.22,2.22,0,0,1-3.024.81h0a2.221,2.221,0,0,1-.81-3.024l4.837-8.377a2.221,2.221,0,0,1,3.024-.81m-65.9,0h0a2.22,2.22,0,0,1,3.024.81l4.836,8.377a2.22,2.22,0,0,1-.81,3.024h0a2.22,2.22,0,0,1-3.024-.81l-4.836-8.377A2.219,2.219,0,0,1,1485.194,716.846Zm-24.12,24.121h0a2.22,2.22,0,0,1,3.024-.81l8.377,4.836a2.22,2.22,0,0,1,.81,3.024h0a2.22,2.22,0,0,1-3.024.81l-8.377-4.836A2.22,2.22,0,0,1,1461.073,740.967Zm114.139,0h0a2.221,2.221,0,0,1-.81,3.024l-8.376,4.836a2.219,2.219,0,0,1-3.024-.81h0a2.22,2.22,0,0,1,.811-3.024l8.376-4.836A2.22,2.22,0,0,1,1575.213,740.967Zm8.829,32.949h0a2.22,2.22,0,0,1-2.214,2.213h-9.672a2.22,2.22,0,0,1-2.214-2.213h0a2.22,2.22,0,0,1,2.214-2.214h9.672A2.22,2.22,0,0,1,1584.042,773.915Zm-117.7,0h0a2.22,2.22,0,0,1-2.214,2.213h-9.672a2.22,2.22,0,0,1-2.214-2.213h0a2.22,2.22,0,0,1,2.214-2.214h9.672A2.22,2.22,0,0,1,1466.345,773.915Zm51.8-65.9h0a2.22,2.22,0,0,1,2.213,2.214V719.9a2.221,2.221,0,0,1-2.213,2.214h0a2.221,2.221,0,0,1-2.214-2.214v-9.673A2.221,2.221,0,0,1,1518.143,708.017Z",
    transform: "translate(-1452.245 -589.039)",
    fill: "#fca700",
    fillRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_287",
    "data-name": "Rectangle 287",
    width: 60.873,
    height: 5.808,
    transform: "translate(450.229 310.697)",
    fill: "#a1c7e9"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M2986.508,1473.463h-52.289q-2.466,16.963-4.922,33.853h52.3q2.45-16.909,4.911-33.853m5.483-37.708h-52.3q-2.467,16.963-4.912,33.854h52.288Q2989.535,1452.7,2991.99,1435.756Zm5.482-37.708h-52.3q-2.469,16.963-4.923,33.854h52.3Q2995,1414.993,2997.472,1398.048Zm-51.74-3.853h52.3q2.074-14.263,4.146-28.524h4.809q-2.072,14.262-4.146,28.524c-.194,1.3-.377,2.593-.56,3.853q-2.468,16.963-4.923,33.854c-.183,1.3-.377,2.593-.56,3.853q-2.466,16.963-4.923,33.854c-.182,1.3-.376,2.593-.559,3.854q-2.45,16.963-4.911,33.853c-.194,1.3-.377,2.594-.56,3.853l-1.487,10.233h-4.809l1.488-10.233h-52.3l-1.486,10.233h-4.786l1.487-10.233c.182-1.26.376-2.556.559-3.853q2.468-16.909,4.923-33.853c.182-1.261.365-2.557.56-3.854q2.449-16.909,4.911-33.854c.183-1.26.378-2.557.56-3.853q2.467-16.909,4.923-33.854c.182-1.26.365-2.557.56-3.853q2.072-14.263,4.135-28.524h4.8Q2947.8,1379.933,2945.732,1394.195Z",
    transform: "translate(-2493.867 -1054.974)",
    fill: "#8dbae4",
    fillRule: "evenodd"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M3020.834,1473.463h52.288q2.467,16.963,4.923,33.853h-52.3q-2.45-16.909-4.911-33.853m-5.482-37.708h52.3q2.466,16.963,4.911,33.854h-52.288Q3017.807,1452.7,3015.352,1435.756Zm-5.483-37.708h52.3q2.468,16.963,4.923,33.854h-52.3Q3012.341,1414.993,3009.868,1398.048Zm51.741-3.853h-52.3q-2.072-14.263-4.145-28.524h-4.809q2.073,14.262,4.146,28.524c.194,1.3.377,2.593.56,3.853q2.467,16.963,4.923,33.854c.183,1.3.376,2.593.56,3.853q2.467,16.963,4.922,33.854c.182,1.3.377,2.593.56,3.854q2.449,16.963,4.911,33.853c.195,1.3.376,2.594.56,3.853l1.487,10.233h4.808l-1.487-10.233h52.3l1.486,10.233h4.786l-1.487-10.233c-.182-1.26-.377-2.556-.56-3.853q-2.466-16.909-4.922-33.853c-.183-1.261-.366-2.557-.56-3.854q-2.45-16.909-4.911-33.854c-.183-1.26-.377-2.557-.56-3.853q-2.467-16.909-4.922-33.854c-.183-1.26-.366-2.557-.56-3.853q-2.074-14.263-4.135-28.524h-4.8Q3059.536,1379.933,3061.609,1394.195Z",
    transform: "translate(-2549.051 -1054.974)",
    fill: "#9ed8f5",
    fillRule: "evenodd"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(460.509 220.641)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_288",
    "data-name": "Rectangle 288",
    width: 28.375,
    height: 29.461,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-13)"
  })))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M3146.514,1297.922l19.323,13.586.853,60.514c.147.169.292.336.435.5.111.129.223.254.334.377.266.3.527.579.788.84.117.119.235.235.355.345,1.923,1.81,4.246,2.1,6.155,2.407,1.477.239,2.608.323,3.746,2.183a1.022,1.022,0,0,1,.087.178,1.108,1.108,0,0,1-.974,1.5l-17.22.827a1.667,1.667,0,0,1-1.756-1.7l.551-7.59a.27.27,0,0,1,0-.032c-1.578-14.6-6.593-35.793-5.236-53.106,0,0-21.225-24.874-21.221-25.658s13.778,4.829,13.778,4.829",
    transform: "translate(-2642.841 -1003.501)",
    fill: "#f4b1b1"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M3134.258,1336.413c-.749,6.463,3.76,10.3,3.012,16.761-.011,16.181-11.348,34.825-15.183,51.164-.127.541.839,5.68.729,6.216-1.7,1.821-6.556,4.39-7.077-4.007,2.171-14.109,4.87-36.909,10.459-54.073l-3.529-17.113Z",
    transform: "translate(-2630.799 -1033.5)",
    fill: "#f4b1b1"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(460.113 271.869)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_289",
    "data-name": "Rectangle 289",
    width: 82.662,
    height: 60.478,
    transform: "translate(-11.294 -2.592)",
    fill: "url(#linear-gradient-14)"
  })))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M3130.131,1121.49c0,.009-2.529,18.776,1.226,27.683.478,1.134.1,1.472,1.7,3.052,3.418,3.383,6.886,9.05,8.914,9.52,7.377,1.711,10.724.309,9.971-4.534-.233-1.5-2.992-2.969-6.069-3.926-2.652-.824-6.241-7.167-7.8-10.794-4.5-10.511-4-26.505-11.948-31.784-.9-.583,1.358,6.8,4,10.782",
    transform: "translate(-2638.016 -874.315)",
    fill: "#b8036f",
    fillRule: "evenodd"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M3017.246,1107.815c-3.291,13.429,10.974,10.372,7.988,37.482,9.875,1.371,20.864,1.75,29.354-.341-1.358-9.975.331-15.319.725-20.766a27.462,27.462,0,0,0-4.641-18.1c-2.9-4.5-27.864-6.574-33.427,1.72",
    transform: "translate(-2560.667 -868.28)",
    fill: "#dc0482",
    fillRule: "evenodd"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M3046.266,1228.135a29.594,29.594,0,0,1-.411,6.415,42.435,42.435,0,0,0,6.775.589c-.823-1.812-4.386-5.679-6.364-7",
    transform: "translate(-2581.288 -957.533)",
    fill: "#b8036f",
    fillRule: "evenodd"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M3078.358,1049.128l-.829,3.209.355.525c1.278,2.455-1.806,5.911-3.844,5.21-5.312-1.2-8.139-6.614-5.916-8.508l.9-.572,1.407-4.477c-.266-.091-1.923-1.756-2.459-2.1a3.153,3.153,0,0,1-.807-2.918c.273-1.208,2.007-.311,2.007-.311-1.382-3.672-3.214-6.868.825-8.7s12.008-1.349,12.008-1.349l4.964-.311c-1.01,1.4-1.742,4.8-1.484,8.381.365,5.084-2.708,11.035-7.124,11.923",
    transform: "translate(-2596.332 -816.324)",
    fill: "#f4b1b1",
    fillRule: "evenodd"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M3085.263,1086.837s1.339,5.1,3.331,6.087,1,.39,1.81.515l.83-3.21c-1.514-.17-2.9-.679-5.971-3.391",
    transform: "translate(-2609.208 -857.426)",
    fill: "#e98385",
    fillRule: "evenodd"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M3002.6,1113.869c-12.253,3.8-11.3,30.666-9.558,38.152,1.486,6.078,22.148,21.459,27.407,19.811,2.537-.8,4.216-3.759.762-6.484-1.205-1.417-17.69-15.051-17.861-16.542-.4-9.628,7.765-35.485-.751-34.937",
    transform: "translate(-2543.142 -876.571)",
    fill: "#dc0482",
    fillRule: "evenodd"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M3124.907,1303.94l-32.011.479,11.1,9.533h35.187Z",
    transform: "translate(-2614.615 -1011.239)",
    fill: "#3b87c8",
    fillRule: "evenodd"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M3176.2,1249.476h-40.073l-5.143,25.89h40.073l5.458-25.671Z",
    transform: "translate(-2641.596 -972.653)",
    fill: "#a1c7e9",
    fillRule: "evenodd"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M3087,1296.127l1.215.671,4.364.073c.511-.122,3.722-.247,2.71.609-.71.6-2.528,1.312-2.5,1.4,1.448,1.08,5.355,3.472,5.394,3.576.543,1.454-3.3-.516-3.913-.74-.161-.059,2.515,2.053,2.377,2.138a1.3,1.3,0,0,1-1.271.13c-.82-.322-2.439-1.594-2.632-1.5s2.417,2.139,2.223,2.212a1.146,1.146,0,0,1-.959-.034c-.84-.358-2.316-1.648-2.546-1.6s1.527,1.355,1.565,1.575c.028.153-.272.3-.432.251-4.306-1.433-3.153-2.719-8.126-4.227-2.767-.84,1.477-4.274,2.531-4.524",
    transform: "translate(-2607.989 -1005.704)",
    fill: "#f4b1b1",
    fillRule: "evenodd"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(445.173 207.311)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_290",
    "data-name": "Rectangle 290",
    width: 51.484,
    height: 42.117,
    transform: "translate(-1.89 0)",
    fill: "url(#linear-gradient-15)"
  })))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M3236.194,1575.968s6.112,1.181,5.99,3.046c-.248,3.767-20.973,2.938-21.094,2.811-.8-.848-1.218-5.042-.339-6.374.655-.989,9.084,3.36,15.442.517",
    transform: "translate(-2704.851 -1203.494)",
    fill: "#031542",
    fillRule: "evenodd"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M3120.147,1585.614c-.13,2.4-8.793,1.709-10.1.99-1.937-1.069.423-8.613,1.155-7.774,0,0,2.259,3.555,4.929,2.838s1.734-1.511,2.191-.611c.855,1.685,1.942,2.347,1.822,4.557",
    transform: "translate(-2626.24 -1205.947)",
    fill: "#000446",
    fillRule: "evenodd"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M3204.646,1284.466a2.407,2.407,0,1,0,2.51,2.4,2.459,2.459,0,0,0-2.51-2.4",
    transform: "translate(-2692.01 -997.442)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(96.321 20.921)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_291",
    "data-name": "Rectangle 291",
    width: 104.796,
    height: 85.849,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-16)"
  })))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M1900.88,470.114a22.865,22.865,0,1,1-22.865,22.865,22.865,22.865,0,0,1,22.865-22.865",
    transform: "translate(-1753.896 -420.489)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M1898.311,526.165a3.526,3.526,0,1,1,5.582-4.31l5.189,6.722,16.515-14.182a3.528,3.528,0,0,1,4.587,5.361l-19.329,16.6h0l-.138.111a3.526,3.526,0,0,1-4.946-.636Z",
    transform: "translate(-1767.753 -451.261)",
    fill: "#24a1fb"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M2887.265,1573.935c-.151,1.218-.611,1.783-.329,2.967a14.537,14.537,0,0,1,.325,3.458c-.055.7-.483,3.185-1.7,3.133a.439.439,0,0,1-.332-.158c-.226.533-1.049.04-1.339-.141-.283.505-1.2.137-1.451-.179-.343.846-1.988-.219-2.475-1.535-.658-.624-.556-2.613-.4-3.309a3.541,3.541,0,0,1,.446-.973c.5-.934,1.262-2.238,1.4-2.5.327-.619.835-1.139.8-1.862Z",
    transform: "translate(-2463.394 -1201.747)",
    fill: "#f4b1b1"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(399.577 311.321)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_292",
    "data-name": "Rectangle 292",
    width: 27.477,
    height: 67.279,
    transform: "translate(-0.952 -0.617)",
    fill: "url(#linear-gradient-17)"
  })))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M2617.8,1391.455l-1.521-1.888-.994-5.141c.038-.629-.481-4.448-1.282-3.075-.563.965-1.131,3.491-1.24,3.476a38.841,38.841,0,0,0-5.8-6.078c-1.831-.34.947,3.645,1.338,4.321.188.324-1.114-1.1-1.3.58-.057.519.292.5.5,1.114.132.387-.86-1.057-1.021.284-.106.888.146.9.355,1.408.06.148-.322-.187-.559-.079-.192.088-.272.589-.081.917,2.451,4.206,4.3,2.464,7.026,7.843,1.566,3.093,4.505-2.385,4.581-3.682",
    transform: "translate(-2269.716 -1064.225)",
    fill: "#f4b1b1",
    fillRule: "evenodd"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    transform: "translate(364.135 323.026)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_293",
    "data-name": "Rectangle 293",
    width: 58.865,
    height: 162.155,
    transform: "translate(-1.757 -19.294)",
    fill: "url(#linear-gradient-18)"
  })))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M2768.906,1269.147s-8.11-3.029-11.85,3.144c-.937,1.544-2.4,1.786-2.366,3.881a21.569,21.569,0,0,1-.232,3.6c-.191,1.117-1.053,2.771-1.236,3.674-.228,1.125,1.448,1.727,1.485,2.22.284,3.923.518,5.809,2.323,6.479,4.559.639,10.966.917,13.058-2.946s3.984-9.445,3.893-13.177-2.944-5.8-5.073-6.878",
    transform: "translate(-2373.947 -986.062)",
    fill: "#f4b1b1"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M2772.961,1331.051a6.818,6.818,0,0,1-.214,3.172c-.542,1.047,10.2,1.075,10.2,1.075a70.677,70.677,0,0,1,2.524-10.507c1.655-4.812-12.512,6.26-12.512,6.26",
    transform: "translate(-2387.782 -1025.153)",
    fill: "#f4b1b1"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(377.834 280.653)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_294",
    "data-name": "Rectangle 294",
    width: 32.197,
    height: 26.884,
    transform: "translate(-1.788 -2.662)",
    fill: "url(#linear-gradient-19)"
  })))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M2770.606,1353.031s.034-2,.941-2.192,10.594-.822,11.708-.385l.122,2.545s-2.85.859-12.771.031",
    transform: "translate(-2386.279 -1044.086)",
    fill: "#dbdcdc"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M2771.3,1312.2c.17-.71,1.916-3.619,2.608-1.443s-1.046,5.1-2.016,4.851-1.023-1.605-.593-3.408",
    transform: "translate(-2386.592 -1015.504)",
    fill: "#f4b1b1"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    transform: "translate(368.091 308.196)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_295",
    "data-name": "Rectangle 295",
    width: 45.319,
    height: 78.617,
    transform: "translate(0 -2.022)",
    fill: "url(#linear-gradient-20)"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    transform: "translate(343.306 315.047)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_296",
    "data-name": "Rectangle 296",
    width: 41.234,
    height: 40.849,
    transform: "translate(-1.064 -3.408)",
    fill: "url(#linear-gradient-21)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightImg);
export default __webpack_public_path__ + "static/media/right-img.6cf5417429dadd9e839db629635c1665.svg";
export { ForwardRef as ReactComponent };